import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import ContactSupportModal from "./ContactSupportModal";

export type ContactSupportModalContextValue = {
  openContactSupport: () => void;
};

const ContactSupportModalContext = createContext<ContactSupportModalContextValue | null>(null);

export function ContactSupportModalProvider({ children }: { children: React.ReactNode }) {
  const [show, setShow] = useState(false);
  const openContactSupport = useCallback(() => setShow(true), []);
  const onHide = useCallback(() => setShow(false), []);
  const value = useMemo(() => ({ openContactSupport }), [openContactSupport]);

  return (
    <ContactSupportModalContext.Provider value={value}>
      {children}
      <ContactSupportModal show={show} onHide={onHide} />
    </ContactSupportModalContext.Provider>
  );
}

export function useContactSupportModal(): ContactSupportModalContextValue {
  const ctx = useContext(ContactSupportModalContext);
  if (!ctx) {
    return { openContactSupport: () => {} };
  }
  return ctx;
}
